import { render, staticRenderFns } from "./ManageInventory.vue?vue&type=template&id=4e27ed09&"
import script from "./ManageInventory.vue?vue&type=script&lang=ts&"
export * from "./ManageInventory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports